import {
    Delete,
    GET,
    POST
} from "../util";

const debtorIpuUrl = "api/debtor-ipu-request-inspection";
const debtorIpuOperationUrl = "api/debtor-ipu-request-operation";

const url = {
    list: `${debtorIpuUrl}/list`,
    confirm: `${debtorIpuOperationUrl}/confirm`,
    decline: `${debtorIpuOperationUrl}/decline`,
};

const debtorIpuApi = {

    list: (params = {}) => {
        return POST(url.list, params);
    },

    confirm: (params) => {
        return POST(url.confirm, params, "application/json", 'Array');
    },

    decline: (params) => {
        return POST(url.decline, params, "application/json", 'Array');
    },
};

export {
    debtorIpuApi
};